// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../apps/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../apps/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sRHxry4IteEtoUlbFWKp{border-bottom:1px dotted currentcolor;cursor:help}\n", "",{"version":3,"sources":["webpack://./../frontend/packages/markdown/dist/extensions/vocabularyDefinition/vocabularyDefinition.module.css"],"names":[],"mappings":"AAAA,sBAAgB,qCAAqC,CAAC,WAAW","sourcesContent":["._vocab_1nye9_1{border-bottom:1px dotted currentcolor;cursor:help}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"_vocab_1nye9_1": "sRHxry4IteEtoUlbFWKp"
};
export default ___CSS_LOADER_EXPORT___;
